/* Accueil, seconde moitié : effets des sections wh-temoignages, wh-quotidien et wh-faq.
   Portage sans framework des composants "use client" de la maquette, mêmes réglages :
   - témoignages : src/template/temoignages/OngletsTemoignages.tsx (onglets + Swiper libre) ;
   - quotidien : src/template/quotidien/SliderQuotidien.tsx (Swiper centré en boucle) ;
   - FAQ : src/template/faq/SectionFaq.tsx (onglets + accordéons).
   Le fichier peut être inclus par plusieurs sections : il ne s'installe qu'une fois.
   Swiper vient de swiper-bundle (chargé en defer avant ce fichier). La maquette n'importe
   que les modules qu'elle utilise ; le bundle les embarque tous et active l'accessibilité
   (A11y) par défaut : on la coupe pour garder exactement le comportement de la maquette. */
(function () {
  if (window.WhAccueilB) return;

  var instances = new Map(); /* élément racine -> fonction de nettoyage */

  function tableau(liste) {
    return Array.prototype.slice.call(liste);
  }

  /* ---------- Témoignages (OngletsTemoignages.tsx) ---------- */
  /* Mêmes réglages Swiper que drinknuoro.com (boucle, largeur auto, défilement libre qui se
     cale sur une carte, molette horizontale seulement). Un slider n'est monté qu'au premier
     affichage de son onglet : caché, il n'a pas de largeur à mesurer. */
  function temoignages(racine) {
    var panneaux = tableau(racine.querySelectorAll('[data-role="tab-content"]'));
    var boutons = tableau(racine.querySelectorAll('[data-role="tab-button"]'));
    var sliders = new Map();

    function monter(panneau) {
      var cle = panneau.dataset.key || "";
      if (sliders.has(cle) || typeof Swiper === "undefined") return;
      sliders.set(
        cle,
        new Swiper(panneau, {
          loop: true,
          slidesPerView: "auto",
          spaceBetween: 16,
          simulateTouch: true,
          allowTouchMove: true,
          freeMode: { enabled: true, sticky: true },
          mousewheel: { enabled: true, forceToAxis: true },
          breakpoints: { 768: { spaceBetween: 20 } },
          a11y: { enabled: false }
        })
      );
    }

    var visible = panneaux.find(function (p) { return !p.hidden; });
    if (visible) monter(visible);

    function choisir(bouton) {
      var cle = bouton.dataset.key;
      boutons.forEach(function (b) {
        var actif = b === bouton;
        b.classList.toggle("active", actif);
        b.setAttribute("aria-selected", String(actif));
      });
      panneaux.forEach(function (p) {
        p.hidden = p.dataset.key !== cle;
        if (!p.hidden) monter(p);
      });
    }

    var ecouteurs = boutons.map(function (b) {
      var f = function () { choisir(b); };
      b.addEventListener("click", f);
      return function () { b.removeEventListener("click", f); };
    });

    /* Éditeur Shopify : un avis sélectionné affiche son onglet. */
    function surBloc(e) {
      var panneau = e.target.closest && e.target.closest('[data-role="tab-content"]');
      if (!panneau || !racine.contains(panneau)) return;
      var bouton = boutons.find(function (b) { return b.dataset.key === panneau.dataset.key; });
      if (bouton) choisir(bouton);
    }
    document.addEventListener("shopify:block:select", surBloc);

    return function () {
      ecouteurs.forEach(function (retirer) { retirer(); });
      document.removeEventListener("shopify:block:select", surBloc);
      sliders.forEach(function (s) { s.destroy(true, true); });
    };
  }

  /* ---------- Au quotidien (SliderQuotidien.tsx) ---------- */
  /* Rangée centrée et en boucle : la carte au centre est la carte active, que la feuille de
     style rend plus haute. On démarre sur la photo du milieu de la série. */
  function quotidien(el) {
    if (el.classList.contains("swiper-initialized") || typeof Swiper === "undefined") return null;
    /* depart = Math.floor(visuels.length / 2) : la série d'origine, sans sa copie cachée. */
    var depart = Math.floor(el.querySelectorAll(".swiper-slide:not([aria-hidden])").length / 2);
    var s = new Swiper(el, {
      loop: true,
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween: 12,
      initialSlide: depart,
      grabCursor: true,
      speed: 500,
      breakpoints: { 600: { spaceBetween: 16 }, 1024: { spaceBetween: 20 } },
      a11y: { enabled: false }
    });
    /* Seules les vidéos visibles tournent : la série peut être répétée plusieurs fois,
       on évite de décoder une douzaine de vidéos en même temps (téléphone). */
    var videos = tableau(el.querySelectorAll("video"));
    /* La vidéo n'est téléchargée qu'à son arrivée à l'écran (src posé depuis data-src). */
    function charger(v) { if (!v.getAttribute("src") && v.dataset.src) v.src = v.dataset.src; }
    function lire(v) { if (window.whVideosCoupees) return; charger(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    /* Boutons son / lecture en bas à droite de chaque carte vidéo. */
    function maj(v) {
      var carte = v.closest(".wh-qt__carte"); if (!carte) return;
      var bs = carte.querySelector("[data-qt-son]"), bl = carte.querySelector("[data-qt-lecture]");
      if (bs) {
        bs.setAttribute("data-etat", v.muted ? "off" : "on");
        bs.setAttribute("aria-pressed", String(!v.muted));
        bs.setAttribute("aria-label", v.muted ? "Activer le son" : "Couper le son");
      }
      if (bl) {
        bl.setAttribute("data-etat", v.paused ? "pause" : "lecture");
        bl.setAttribute("aria-label", v.paused ? "Lire la vidéo" : "Mettre en pause");
      }
    }
    videos.forEach(function (v) {
      ["play", "pause", "volumechange"].forEach(function (ev) { v.addEventListener(ev, function () { maj(v); }); });
      maj(v);
    });
    function clic(e) {
      var b = e.target.closest("[data-qt-son], [data-qt-lecture]");
      if (!b || !el.contains(b)) return;
      e.preventDefault();
      e.stopPropagation();
      var v = b.closest(".wh-qt__carte").querySelector("video");
      if (!v) return;
      if (b.hasAttribute("data-qt-son")) {
        if (v.muted) {
          videos.forEach(function (o) { if (o !== v) o.muted = true; });
          v.muted = false;
          v.__pauseManuelle = false;
          lire(v);
        } else {
          v.muted = true;
        }
      } else if (v.paused) {
        v.__pauseManuelle = false;
        lire(v);
      } else {
        v.__pauseManuelle = true;
        v.pause();
      }
    }
    el.addEventListener("click", clic, true);
    var obs = null;
    if ("IntersectionObserver" in window && videos.length) {
      obs = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { if (!v.__pauseManuelle) lire(v); }
          else v.pause();
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { obs.observe(v); });
    } else {
      videos.forEach(lire);
    }
    return function () { if (obs) obs.disconnect(); el.removeEventListener("click", clic, true); s.destroy(true, true); };
  }

  /* ---------- FAQ (SectionFaq.tsx) ---------- */
  /* État de la maquette : un onglet actif ; changer d'onglet n'ouvre que la première question
     de cet onglet ; chaque question s'ouvre et se ferme indépendamment. */
  function faq(section) {
    var onglets = tableau(section.querySelectorAll("[data-faq-tab]"));
    var items = tableau(section.querySelectorAll(".faq-v2__list__item"));

    function ouvrir(item, oui) {
      item.classList.toggle("is-open", oui);
      var bouton = item.querySelector("[data-faq-toggle]");
      if (bouton) bouton.setAttribute("aria-expanded", String(oui));
    }

    function choisirOnglet(tab) {
      onglets.forEach(function (o) { o.classList.toggle("is-active", o.dataset.faqTab === tab); });
      var premier = items.find(function (it) { return it.dataset.faqItem === tab; });
      items.forEach(function (it) {
        it.hidden = it.dataset.faqItem !== tab;
        ouvrir(it, it === premier);
      });
    }

    var ecouteurs = [];
    onglets.forEach(function (o) {
      var f = function () { choisirOnglet(o.dataset.faqTab); };
      o.addEventListener("click", f);
      ecouteurs.push(function () { o.removeEventListener("click", f); });
    });
    items.forEach(function (it) {
      var bouton = it.querySelector("[data-faq-toggle]");
      if (!bouton) return;
      var f = function () { ouvrir(it, !it.classList.contains("is-open")); };
      bouton.addEventListener("click", f);
      ecouteurs.push(function () { bouton.removeEventListener("click", f); });
    });

    /* Éditeur Shopify : une question sélectionnée affiche son onglet, ouverte. */
    function surBloc(e) {
      var item = e.target.closest && e.target.closest(".faq-v2__list__item");
      if (!item || !section.contains(item)) return;
      choisirOnglet(item.dataset.faqItem);
      ouvrir(item, true);
    }
    document.addEventListener("shopify:block:select", surBloc);
    ecouteurs.push(function () { document.removeEventListener("shopify:block:select", surBloc); });

    return function () { ecouteurs.forEach(function (retirer) { retirer(); }); };
  }

  /* ---------- Montage ---------- */
  var MODULES = [
    { selecteur: ".wh-ms", monter: temoignages },
    { selecteur: ".wh-qt__rangee", monter: quotidien },
    { selecteur: ".tpl-coziya section.faq-v2", monter: faq }
  ];

  function initialiser(portee) {
    MODULES.forEach(function (m) {
      var racines = tableau(portee.querySelectorAll(m.selecteur));
      if (portee.matches && portee.matches(m.selecteur)) racines.unshift(portee);
      racines.forEach(function (racine) {
        if (instances.has(racine)) return;
        var nettoyer = m.monter(racine);
        if (nettoyer) instances.set(racine, nettoyer);
      });
    });
  }

  function nettoyer(portee) {
    instances.forEach(function (fin, racine) {
      if (portee === racine || portee.contains(racine)) {
        fin();
        instances.delete(racine);
      }
    });
  }

  window.WhAccueilB = { initialiser: initialiser, nettoyer: nettoyer };

  /* Swiper arrive après la lecture de la page (window.whLibs, layout/theme.liquid). */
  function demarrer() { (window.whLibs || Promise.resolve()).then(function () { initialiser(document); }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();

  document.addEventListener("shopify:section:load", function (e) { initialiser(e.target); });
  document.addEventListener("shopify:section:unload", function (e) { nettoyer(e.target); });
})();
